import { render, staticRenderFns } from "./ExplorerInfoTab.vue?vue&type=template&id=209ff908"
import script from "./ExplorerInfoTab.vue?vue&type=script&lang=ts"
export * from "./ExplorerInfoTab.vue?vue&type=script&lang=ts"
import style0 from "./ExplorerInfoTab.vue?vue&type=style&index=0&id=209ff908&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('209ff908')) {
      api.createRecord('209ff908', component.options)
    } else {
      api.reload('209ff908', component.options)
    }
    module.hot.accept("./ExplorerInfoTab.vue?vue&type=template&id=209ff908", function () {
      api.rerender('209ff908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Explorer/ExplorerInfoTab.vue"
export default component.exports